import { Component } from '@angular/core';
import { Platform, NavController, ToastController, MenuController } from 'ionic-angular';

import { Componentes } from '../../providers/componentes';
import { ClubeProvider } from '../../providers/clube';
import { PushProvider } from '../../providers/push';
import { LocalStorageProvider } from './../../providers/local-storage';
import { EventosPage } from '../../pages/eventos/eventos'
import { OfertasPage } from '../../pages/ofertas/ofertas'

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

  username: string;
  userid: number = 0;
  userpoints: any;
  logado: boolean = false;
  guid: string;

  constructor(
    public componentes: Componentes,
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public menucontroller: MenuController,
    public clubeProvider: ClubeProvider,
    public pushProvider: PushProvider,
    public platform: Platform,
    public localStorage: LocalStorageProvider,
  ) {
    this.userpoints = 0;
  }

  ionViewDidLoad() {
    this.menucontroller.swipeEnable(true)
  }

  openOfertasPage() {
    this.navCtrl.push(OfertasPage);
  }

  openPage(page) {
    this.navCtrl.push(page);
  }

  openEventosPage() {
    this.navCtrl.push(EventosPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts